// extracted by mini-css-extract-plugin
export default {"table":"RelationTable_table__mAYLE","row":"RelationTable_row__BaJ36","cell":"RelationTable_cell__B2czo","header":"RelationTable_header__U69Pr"};